module.exports = __webpack_public_path__ + "media/images/sp/visit_reserve/about-reserve-792fdd6bb1c9baac7c8bc3e1f38b0aac.png";